import "@/App.css";
import "@/index.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";
import { Toaster } from "sonner";
import { OperatorProvider } from "@/context/OperatorContext";
import AuthGate from "@/components/AuthGate";
import BootSequence from "@/components/BootSequence";
import Shell from "@/components/Shell";
import CommandDeck from "@/pages/CommandDeck";
import Treasury from "@/pages/Treasury";
import Crew from "@/pages/Crew";
import Clients from "@/pages/Clients";
import Jobs from "@/pages/Jobs";
import Catalog from "@/pages/Catalog";
import CheckoutResult from "@/pages/CheckoutResult";
import Settings from "@/pages/Settings";
import GoldHunterApp from "@/goldhunter/GoldHunterApp";

// YABBAI Orchestra (the current agency OS), wrapped in its own command-deck chrome.
function OrchestraApp() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<CommandDeck />} />
        <Route path="/treasury" element={<Treasury />} />
        <Route path="/crew" element={<Crew />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/checkout/success" element={<CheckoutResult status="success" />} />
        <Route path="/checkout/cancel" element={<CheckoutResult status="cancel" />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}

function App() {
  const [booted, setBooted] = useState(false);

  return (
    <OperatorProvider>
      <BootSequence onDone={() => setBooted(true)} />
      <div style={{ minHeight: "100vh", opacity: booted ? 1 : 0, transition: "opacity .4s ease" }}>
        <BrowserRouter>
          <Routes>
            {/* Where Google returns the user mid-sign-in. Must stay outside the
                gate — at this point they are, by definition, not yet signed in. */}
            <Route
              path="/sso-callback"
              element={<AuthenticateWithRedirectCallback signInFallbackRedirectUrl="/" />}
            />
            {/* Everything else is private: no page renders until the operator is
                signed in, allowlisted, and past their authenticator check. */}
            <Route
              path="/*"
              element={
                <AuthGate>
                  <Routes>
                    {/* Legacy Gold-Hunter app runs standalone under /gold */}
                    <Route path="/gold/*" element={<GoldHunterApp />} />
                    {/* Everything else is the Orchestra app */}
                    <Route path="/*" element={<OrchestraApp />} />
                  </Routes>
                </AuthGate>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "var(--yb-panel)",
              border: "1px solid var(--yb-hairline)",
              color: "var(--yb-text)",
              fontFamily: "'Chakra Petch', sans-serif",
            },
          }}
        />
      </div>
    </OperatorProvider>
  );
}

export default App;
